import CaseDetails from './CaseDetails';
import CaseDetailsNavigation from './CaseDetailsNavigation';

export default CaseDetails;
export {
  CaseDetailsNavigation
};
